import { GetterTree } from 'vuex'
import { ServiceProvidersState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<ServiceProvidersState, RootState> = {
  serviceProviders:state => state.service_providers,
  serviceProviderItem:state => state.serviceProviderItem,
};